import { render, staticRenderFns } from "./CommandBaseAccount.vue?vue&type=template&id=207ad559&"
import script from "./CommandBaseAccount.js?vue&type=script&lang=js&"
export * from "./CommandBaseAccount.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports